import { UseUserContext } from "../context/UserContext";

const UserGravatar = () => {
  const { currentUser } = UseUserContext();
  const gravatar = require('gravatar');
  return String(gravatar.url(currentUser.auth.email));
}

export default UserGravatar;